<template>
  <div
    v-cloak
    v-if="content.data"
    class="form__wrapper"
    v-bind:class="{
      full: modalShow,
      active: isActive,
      fullBlue: fullInvitation,
    }"
  >
    <div class="form__top">
      <p v-html="content.data.form.header_0"></p>
      <div
        class="form__submit"
        @click="showBox"
        v-html="content.data.form.btn"
      ></div>
    </div>

    <div class="form__box">
      <div class="form__bottom">
        <form>
          <div class="form__invitation-wrapper">
            <div class="form__invitation">
              {{ content.data.form.header_1 }}
            </div>
            <Invitation
              @minus="counterDown"
              @open="checkPaymentType"
              @plus="counterUp"
              :value="appData.formAmountValue"
            />
            <div class="back back--invitation" @click="closeInvitation">
              <span class="d-none d-lg-block">Powrót do strony </span>
              <span class="d-block d-lg-none">X</span>
            </div>
          </div>
          <div class="form__legend">
            <b-modal
              v-model="modalShow"
              id="modal-payment"
              hide-footer
              hide-header
              hide-backdrop
              no-close-on-backdrop
              no-close-on-esc
              body-class="p-0"
            >
              <div>
                <div
                  class="form__cong text-center"
                  v-html="content.data.form.introPayment"
                ></div>
                <div>
                  <b-form
                    id="form-modal"
                    class="form__core"
                    @change="changedForm"
                  >
                    <div class="text-center mx--1 pb-2 form__info">
                      <div>
                        {{ content.data.form.contentPayment }}
                        {{ form.amount }}
                        {{ content.data.form.contentPayment_1 }}
                      </div>
                      <div v-if="showFirstFormPart">
                        <AmountSelect
                          class="py-2 pt-2"
                          @minus="counterDown"
                          @plus="counterUp"
                          :value="appData.formAmountValue"
                        />

                        <input
                          v-model="form.amount"
                          :v="$v.form.amount"
                          type="hidden"
                        />

                        <div v-if="$v.form.amount.$dirty">
                          <div
                            class="text-danger text-danger-min"
                            v-if="!$v.form.amount.minValue"
                          >
                            Ups, minimalna kowota: 35
                          </div>
                          <div
                            class="text-danger"
                            v-if="!$v.form.amount.maxValue"
                          >
                            Ups, maksymalna kwota wsparcia: 5 000 - chcesz
                            podarować więcej? Napisz do nas na
                            spl@greenpeace.org
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                id="name"
                                autocomplete="given-name"
                                v-on:click="onClickElement('name')"
                                v-model="form.name"
                                :v="$v.form.name"
                                required
                                placeholder="Imię*"
                                :class="{ 'is-invalid': $v.form.name.$error }"
                              ></b-form-input>
                              <div
                                v-if="$v.form.name.$dirty"
                                class="text-danger-name"
                              >
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.name.required"
                                >
                                  <small>Pole wymagane</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.name.minLength"
                                >
                                  <small>
                                    Minimalna długość imienia to 3 znaki
                                  </small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.name.maxLength"
                                >
                                  <small>
                                    Zbyt długie imię. Maksymalna długość to 255
                                    znaków</small
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                id="surname"
                                v-on:click="onClickElement('surname')"
                                autocomplete="family-name"
                                v-model="form.surname"
                                required
                                placeholder="Nazwisko*"
                                :class="{
                                  'is-invalid': $v.form.surname.$error,
                                }"
                              ></b-form-input>
                              <div v-if="$v.form.surname.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.surname.required"
                                >
                                  <small>Pole wymagane</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.surname.minLength"
                                >
                                  <small
                                    >Minimalna długość nazwiska to 3
                                    znaki</small
                                  >
                                </div>
                                <div
                                  class="text-danger"
                                  v-if="!$v.form.surname.maxLength"
                                >
                                  Zbyt długie nazwisko. Maksymalna długość to
                                  255 znaków
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                id="email"
                                :v="$v.form.email"
                                v-model="form.email"
                                v-on:click="onClickElement('email')"
                                type="email"
                                required
                                placeholder="Email*"
                                :class="{ 'is-invalid': $v.form.email.$error }"
                              ></b-form-input>
                              <div v-if="$v.form.email.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.email.required"
                                >
                                  <small>Pole wymagane</small>
                                </div>
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.email.email"
                                >
                                  <small>Wpisz poprawny email</small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                id="name"
                                autocomplete="phone"
                                v-model="form.phone"
                                v-on:click="onClickElement('name')"
                                v-on:keypress="onEnterPhone"
                                v-on:blur="onBlurPhone"
                                placeholder="Telefon*"
                              ></b-form-input>
                              <div v-if="$v.form.phone.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.phone.required"
                                >
                                  <small>Pole wymagane</small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                id="birthDate"
                                autocomplete="birthday"
                                v-model="form.birthDate"
                                :type="type"
                                placeholder="Data urodzenia*"
                                onfocus="(this.type='date')"
                              ></b-form-input>
                              <div v-if="$v.form.birthDate.$dirty">
                                <div
                                  class="text-danger text-left"
                                  v-if="!$v.form.birthDate.required"
                                >
                                  <small>Pole wymagane</small>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div>
                              <b-form-input
                                  id="fundraiser"
                                  v-model="form.fundraiser"
                                  :type="type"
                                  placeholder="ID fundraisera"
                              ></b-form-input>
                            </div>
                          </div>
                        </div>

                        <div id="agreementData" class="text-left pt-2">
                          <b-form-checkbox-group
                            v-model="form.agreementData"
                            id="agreementData"
                            v-on:click="onClickElement('agreementData')"
                            class="form__checkboxes"
                            :class="{
                              'is-invalid': $v.form.agreementData.$error,
                            }"
                          >
                            <b-form-checkbox value="agreementData">
                              <div
                                class="pt-1"
                                v-html="content.data.form.agreement_1"
                              ></div>
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                          <div v-if="$v.form.agreementData.$dirty">
                            <div
                              class="text-danger text-left"
                              v-if="!$v.form.agreementData.required"
                            >
                              <small>Ta zgoda jest niezbędna</small>
                            </div>
                          </div>
                        </div>
                        <b-form-group
                          id="agreement"
                          :label="content.data.form.agreement_5"
                          label-for="agreement"
                          class="form__checkboxes text-left pt-1"
                        >
                          <b-form-checkbox-group
                            v-model="form.contactType"
                            id="agreement"
                          >
                            <b-form-checkbox
                              v-on:click="onClickElement('agreementEmail')"
                              value="agreementEmail"
                              class="form__checkboxes"
                              ><span
                                v-html="content.data.form.agreement_3"
                              ></span>
                            </b-form-checkbox>
                            <b-form-checkbox
                              value="agreementPhone"
                              v-on:click="onClickElement('agreementPhone')"
                              class="form__checkboxes"
                              ><span
                                v-html="content.data.form.agreement_4"
                              ></span>
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                        <div
                          class="d-flex align-items-center form__paybtn pt-2"
                        >
                          <div
                            id="onSubmitButton"
                            class="form__pay form__pay--payu"
                            @click="onCardPay"
                          >
                            <img
                              src="../assets/images/icons/PayU.svg"
                              alt="Payu logo"
                              id="payu-single-image"
                            />
                          </div>
                          <div
                            class="form__pay form__pay--paypal ml-2"
                            @click="onSubmit"
                            v-bind:class="{
                              inactive: showCreditCard,
                            }"
                          >
                            <img
                              src="../assets/images/icons/PayPal.svg"
                              alt="Paypal logo"
                              id="paypal-image"
                              @click="showCreditCard = false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="showCreditCard">
                      <div class="pb-2 pb-md-4 text-center form__info">
                        Wpisz dane <b>karty MasterCard lub Visa</b>
                      </div>

                      <div class="row">
                        <div class="col-lg-12">
                          <div>
                            <b-form-input
                              id="pcard"
                              v-on:click="onClickElement('pcard')"
                              class="payu-card-number"
                              v-model="form.pcard"
                              required
                              placeholder="Numer karty"
                              autocomplete="cc-number"
                              v-on:keypress="onEnterCreditCard"
                              v-on:blur="onBlur"
                              autofocus
                            ></b-form-input>
                            <div v-if="$v.form.pcard.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.pcard.required"
                              >
                                <small>Numer karty jest wymagany</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="
                                  !$v.form.pcard.mustBe16 ||
                                  !$v.form.pcard.mustBeNumber
                                "
                              >
                                <small>Podaj poprawny numer</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-6 col-lg-3">
                          <div>
                            <b-form-input
                              id="cmm"
                              autocomplete="cc-exp-month"
                              class="payu-card-expm"
                              v-model="form.cmm"
                              required
                              placeholder="MM"
                              v-on:click="onClickElement('cmm')"
                              v-on:keypress="onEnterMM"
                            ></b-form-input>
                            <div v-if="$v.form.cmm.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.cmm.required"
                              >
                                <small>Miesiąc jest wymagany</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="
                                  !$v.form.cmm.minLength ||
                                  !$v.form.cmm.maxLength
                                "
                              >
                                <small>Wpisz poprawne dane</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.cmm.max12"
                              >
                                <small>Podaj poprawny miesiąc</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6 col-lg-3">
                          <div>
                            <b-form-input
                              id="rrrr"
                              class="payu-card-expy"
                              autocomplete="cc-exp-year"
                              v-on:click="onClickElement('rrrr')"
                              v-model="form.cyy"
                              required
                              placeholder="RRRR"
                              v-on:keypress="onEnterYY"
                            ></b-form-input>

                            <div v-if="$v.form.cyy.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.cyy.required"
                              >
                                <small>Rok jest wymagany</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="
                                  !$v.form.cyy.minLength ||
                                  !$v.form.cyy.maxLength
                                "
                              >
                                <small>Wpisz poprawne dane</small>
                              </div>
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.cyy.checkYear"
                              >
                                <small>Podaj poprawny rok</small>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div>
                            <b-form-input
                              id="cvv"
                              v-on:click="onClickElement('cvv')"
                              class="payu-card-cvv"
                              v-model="form.cvv"
                              required
                              placeholder="CVV"
                              autocomplete="cc-csc"
                              v-on:keypress="onEnterCVV"
                            ></b-form-input>
                            <div v-if="$v.form.cvv.$dirty">
                              <div
                                class="text-danger text-left"
                                v-if="!$v.form.cvv.required"
                              >
                                <small>Numer jest wymagany</small>
                              </div>

                              <div
                                class="text-danger text-left"
                                v-if="
                                  !$v.form.cvv.minLength ||
                                  !$v.form.cvv.maxLength
                                "
                              >
                                <small
                                  >Wpisz poprawny kod CVV. Znajdziesz go z tyłu
                                  karty</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-12">
                          <div
                            id="payuAgreement"
                            role="group"
                            tabindex="-1"
                            class="form__checkboxes text-left bv-no-focus-ring"
                          >
                            <div
                              class="custom-control custom-control-inline custom-checkbox ml-md-3"
                            >
                              <input
                                type="checkbox"
                                name="payuAgreement"
                                v-model="form.payuAgreement"
                                autocomplete="off"
                                class="custom-control-input payu-agreement pt-2"
                                value="true"
                                id="__BVID__108"
                              /><label
                                class="custom-control-label pb-md-4 pt-md-1"
                                for="__BVID__108"
                                v-html="content.data.form.agreement_6"
                              >
                              </label>
                            </div>
                          </div>

                          <div v-if="$v.form.payuAgreement.$dirty">
                            <div
                              class="text-danger text-left"
                              v-if="!$v.form.payuAgreement.required"
                            >
                              <small>Zgoda jest wymagana</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row py-3">
                        <div class="col">
                          <div class="btnS" id="payByCard" @click="payByCard()">
                            Wspieram
                          </div>
                        </div>
                      </div>
                      <div class="form__cardwrap pb-3">
                        <img
                          src="@/assets/images/icons/Mastercard.svg"
                          alt="credit card logo"
                          class="form__logo"
                        />
                        <img
                          src="@/assets/images/icons/visa.svg"
                          alt="credit card logo"
                          class="form__logo"
                        />
                        <img
                          src="@/assets/images/icons/PayU.svg"
                          alt="credit card logo"
                          class="form__logo"
                        />
                      </div>
                      <div class="row">
                        <div class="col text-left form__notice">
                          {{ content.data.form.legalNotice_1 }}
                          <a
                            :href="`mailto: ${content.data.form.legalNotice_5}`"
                            :title="content.data.form.legalNotice_5"
                            >{{ content.data.form.legalNotice_5 }}</a
                          >
                          {{ content.data.form.legalNotice_2 }}
                          <a
                            :href="`tel:48${content.data.form.legalNotice_4}`"
                            :title="content.data.form.legalNotice_4"
                            >{{ content.data.form.legalNotice_4 }}</a
                          >
                          {{ content.data.form.legalNotice_3 }}
                        </div>
                      </div>
                    </div>
                  </b-form>
                </div>
              </div>
              <div class="back back--form" @click="backToPageFromPayment">
                <span class="d-none d-lg-block">Powrót do strony</span>
                <span class="d-block d-lg-none">X</span>
              </div>
            </b-modal>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<!-- FOR OPEN PAYU -->
<script></script>

<script>
import axios from "axios";

import {
  email,
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";
import AmountSelect from "./AmountSelect.vue";
import Invitation from "./Invitation.vue";

export default {
  name: "Form",
  inject: ["content", "appData"],
  data() {
    return {
      title: "Formularz",
      value: this.appData.formAmountValue,
      subscription: false,
      modalShow: false,
      counter: 0,
      counterNum: 0,
      remarketingWelcome: false,
      showCreditCard: false,
      isActive: false,
      showFirstFormPart: true,
      fullInvitation: false,
      type: "text",

      form: {
        inviteToPay: new URLSearchParams(location.search).get("inviteToPay"),
        inviteToSinglePayment: new URLSearchParams(location.search).get(
          "inviteToSinglePayment"
        ),
        fundraiser: new URLSearchParams(location.search).get("fundraiser"),
        tag: new URLSearchParams(location.search).get("tag"),
        email: "",
        name: "",
        surname: "",
        phone: "",
        agreementData: [],
        contactType: [],
        amount: this.appData.formAmountValue,
        cvv: "",
        cyy: "",
        cmm: "",
        pcard: "",
        payuAgreement: [],
        birthDate: "",
      },
    };
  },

  validations() {
    if (this.showCreditCard) {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(35),
            maxValue: maxValue(50000),
          },
          email: {
            required,
            email,
          },
          phone: {
            required,
          },
          birthDate: {
            required,
          },
          agreementData: {
            required,
          },
          payuAgreement: {
            required,
          },
          cvv: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(3),
          },
          cyy: {
            required,
            minLength: minLength(4),
            maxLength: maxLength(4),
            checkYear: (value) => {
              let toTest = parseInt(value, 10);
              let currentYear = new Date().getFullYear();
              if (toTest >= currentYear) {
                return true;
              } else {
                return false;
              }
            },
          },
          cmm: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(2),
            max12: (value) => {
              let toTest = parseInt(value, 10);
              if (toTest <= 12 && toTest > 0) {
                return true;
              } else {
                return false;
              }
            },
          },
          pcard: {
            required,
            mustBe16: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              if (toTest.length != 16) {
                return false;
              } else {
                return true;
              }
            },
            mustBeNumber: (value) => {
              let toTest = value.replace(/\s+|-/g, "");
              let reg = new RegExp("^[0-9]+$");
              if (reg.test(toTest)) {
                return true;
              } else {
                return false;
              }
            },
          },
        },
      };
    } else {
      return {
        form: {
          amount: {
            required,
            minValue: minValue(35),
            maxValue: maxValue(10000),
          },
          email: {
            required,
            email,
          },
          phone: {
            required,
          },
          birthDate: {
            required,
          },
          name: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          surname: {
            required,
            minLength: minLength(3),
            maxLength: maxLength(255),
          },
          agreementData: {
            required,
          },
        },
      };
    }
  },

  methods: {
    counterUp() {
      this.$root.$emit("formAmountUp");
    },
    counterDown() {
      this.$root.$emit("formAmountDown");
    },

    onClickElement: function (name) {
      window.trackFormClick(name);
    },
    onBlur: function () {
      this.form.pcard = this.form.pcard
        .replace(/\W/gi, "")
        .replace(/(.{4})/g, "$1 ")
        .substr(0, 19);
    },
    onBlurPhone: function () {
      this.form.phone = this.form.phone
        .replace(/[^\d\+]/g, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 15);
    },
    onEnterCreditCard: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.pcard = this.form.pcard
        .replace(/\W/gi, "")
        .replace(/(.{4})/g, "$1 ")
        .substr(0, 18);
    },
    onEnterPhone: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }

      this.form.phone = this.form.phone
        .replace(/\W/gi, "")
        .replace(/(.{3})/g, "$1 ")
        .substr(0, 13);
    },
    onEnterMM: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cmm = this.form.cmm.replace(/\W/gi, "").substr(0, 1);
    },
    onEnterYY: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cyy = this.form.cyy.replace(/\W/gi, "").substr(0, 3);
    },
    onEnterCVV: function (event) {
      var charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
      this.form.cvv = this.form.cvv.replace(/\W/gi, "").substr(0, 2);
    },
    onCardPay() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();
        return;
      }
      this.showCreditCard = true;
      this.showFirstFormPart = false;
      setTimeout(function () {
        document
          .getElementById("payByCard")
          .scrollIntoView({ behavior: "smooth" });
      }, 250);
    },
    onSubmit(evt) {
      let onSubmitButton = document.getElementById("onSubmitButton");
      if (onSubmitButton) {
        onSubmitButton.setAttribute("disabled", true);
        setTimeout(() => {
          onSubmitButton.removeAttribute("disabled");
        }, 2000);
      }

      evt.preventDefault();
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "formSendError",
          formName: "Formularz Wspieram",
          errorForm: "1",
        });

        this.validationScrollToError();
        return;
      }
      let type = "";
      if (evt.target.id === "payu-single-image") type = "payu";
      if (evt.target.id === "paypal-image") type = "paypal";

      this.modalShow = false;
      this.$router.push("/pending");
      this.onSubscription(type);
    },
    onSubscription(type) {
      if (type === "paypal") {
        this.callWspieramApi(
          "https://api.rewolucyjna.pl/api/payment/paypal/payment/recurring",
          this.getDataForPayment()
        );
      } else {
        // call via payByCard
        this.$router.push("/error");
      }
    },
    payByCard: function () {
      let buttonPayByCard = document.getElementById("payByCard");
      buttonPayByCard.setAttribute("disabled", true);
      setTimeout(() => {
        buttonPayByCard.removeAttribute("disabled");
      }, 2000);

      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.validationScrollToError();
        return;
      }

      console.log("paybycard called");
      //console.log('paybycard called');
      this.modalShow = false;
      this.$router.push("/pending");

      // must be var!
      var dataForPayment = this.getDataForPayment();
      var router = this.$router;
      console.log("form", this.form);
      dataForPayment["card-expy"] = this.form.cyy;
      dataForPayment["card-expm"] = this.form.cmm;
      console.log("dataForPayment", dataForPayment);
      OpenPayU.merchantId = "191309";
      OpenPayU.Token.create(
        {
          allows_charges: true,
          allows_payouts: true,
        },
        function (payuResponse) {
          Fingerprint2.get({}, function (components) {
            var values = components.map(function (component) {
              return component.value;
            });
            var murmur = Fingerprint2.x64hash128(values.join(""), 31);

            console.log("Finerprint " + murmur);

            console.log("payu response", payuResponse);
            dataForPayment["mask"] = payuResponse.data.mask;
            dataForPayment["token"] = payuResponse.data.token;
            dataForPayment["type"] = payuResponse.data.type;
            dataForPayment["fingerprint"] = murmur;
            axios
              .post(
                "https://api.rewolucyjna.pl/api/payment/payu/payment/recurring",
                dataForPayment,
                {
                  headers: { crossDomain: true },
                }
              )
              .then((response) => {
                console.log("get api response");
                console.log(response);

                if (response.data.redirectUri) {
                  window.location.href = response.data.redirectUri;
                } else {
                  if (response.data.status == "SUCCESS") {
                    router.push("/thankyou_regular");
                  } else if (response.data.status == "WARNING_CONTINUE_CVV") {
                    router.push("/error");
                  } else if (response.data.status == "ERROR_VALUE_INVALID") {
                    router.push("/error");
                  } else if (response.data.status == "WARNING_CONTINUE_3DS") {
                    window.location.href = response.data.redirectUri;
                  } else {
                    router.push("/error");
                  }
                }
              });
          });
        }
      );
    },
    getDataForPayment() {
      return {
        landingPage: "rewolucyjna-targi",
        amount: this.form.amount,
        name: this.form.name,
        surname: this.form.surname,
        email: this.form.email,
        phone: this.form.phone,
        birthDate: this.form.birthDate,
        fundraiser:
          this.form.fundraiser ??
          new URLSearchParams(location.search).get("fundraiser"),
        tag: new URLSearchParams(location.search).get("tag"),
        agreementData: this.form.agreementData.includes("agreementData"),
        agreementEmail: this.form.contactType.includes("agreementEmail"),
        agreementPhone: this.form.contactType.includes("agreementPhone"),
      };
    },
    callWspieramApi(targetUrl, dataForPayment) {
      window.goToPayment();
      axios
        .post(targetUrl, dataForPayment, {
          headers: { crossDomain: true },
        })
        .then((response) => {
          if (response.data.status == "SUCCESS") {
            window.location.href = response.data.redirectUri;
          } else {
            this.$router.push("/error");
          }
        });
    },

    checkPaymentType: function () {
      window.clickAdoptujButton();
      window.trackAdoptionForm();
    },
    showBox: function () {
      this.isActive = true;
    },
    validationScrollToError: function () {
      setTimeout(() => {
        if (document.body.clientWidth < 992) {
          let elementsInErrors =
            document.getElementsByClassName("text-danger-min");
          let elementsInErrorsName =
            document.getElementsByClassName("text-danger-name");
          if (elementsInErrors && elementsInErrors.length > 0) {
            let toScrollInput = document.getElementById("modal-payment");
            toScrollInput.scrollIntoView();
          } else if (elementsInErrorsName && elementsInErrorsName.length > 0) {
            let toScrollInputName = document.getElementById("name");
            toScrollInputName.scrollIntoView();
          }
        }
        if (!this.$v.form.surname?.required) {
          window.errorOnFormField("surname", "Pole jest wymagane");
        } else if (!this.$v.form.surname?.minLength) {
          window.errorOnFormField(
            "surname",
            "Minimalna długość nazwiska to 3 znaki"
          );
        } else if (!this.$v.form.surname?.maxLength) {
          window.errorOnFormField(
            "surname",
            "Zbyt długie Nazwisko. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.name?.required) {
          window.errorOnFormField("name", "Pole jest wymagane");
        } else if (!this.$v.form.name?.minLength) {
          window.errorOnFormField(
            "name",
            "Minimalna długość imienia to 3 znaki"
          );
        } else if (!this.$v.form.name?.maxLength) {
          window.errorOnFormField(
            "name",
            "Zbyt długie imię. Maksymalna długość to 255 znaków"
          );
        }
        if (!this.$v.form.email?.required) {
          window.errorOnFormField("email", "Pole jest wymagane");
        } else if (!this.$v.form.email?.email) {
          window.errorOnFormField("email", "Wpisz poprawny email");
        }
        if (!this.$v.form.agreementData?.required) {
          window.errorOnFormField("agreementData", "Zgoda jest wymagana");
        }
        if (this.$v.form?.payuAgreement) {
          if (!this.$v.form.payuAgreement.required) {
            window.errorOnFormField("payuAgreement", "Zgoda jest wymagana");
            vv;
          }
        }
        if (this.$v.form.pcard) {
          if (!this.$v.form.pcard.required) {
            window.errorOnFormField("pcard", "Padaj numer");
          } else if (
            !this.$v.form.pcard.mustBeNumber ||
            !this.$v.form.pcard.mustBe16
          ) {
            window.errorOnFormField("pcard", "Padaj poprawny numer");
          }
        }
        if (this.$v.form.cvv) {
          if (!this.$v.form.cvv.required) {
            window.errorOnFormField("cvv", "Numer jest wymagany");
          } else if (
            !this.$v.form.cvv.minLength ||
            !this.$v.form.cvv.maxLength
          ) {
            window.errorOnFormField("cvv", "Padaj poprawny numer");
          }
        }
        if (this.$v.form.cmm) {
          if (!this.$v.form.cmm.required) {
            window.errorOnFormField("cmm", "Miesiąc jest wymagany");
          } else if (
            !this.$v.form.cmm.minLength ||
            !this.$v.form.cmm.maxLength ||
            !this.$v.form.cmm.max12
          ) {
            window.errorOnFormField("cmm", "Padaj poprawny miesiąc");
          }
        }
        if (this.$v.form.cyy) {
          if (!this.$v.form.cyy.required) {
            window.errorOnFormField("cyy", "Rok jest wymagany");
          } else if (
            !this.$v.form.cyy.minLength ||
            !this.$v.form.cyy.maxLength ||
            !this.$v.form.cyy.checkYear
          ) {
            window.errorOnFormField("cyy", "Padaj poprawny rok");
          }
        }
      }, 50);
    },
    changedForm(e) {
      let dataToSend = e.target.name ? e.target.name : e.target.id;
      window.formFieldClick(dataToSend);
    },
    closeInvitation: function () {
      this.isActive = false;
    },
    backToPageFromPayment: function () {
      this.$root.$emit("toggleModalPayment", false);
      this.showFirstFormPart = true;
      this.showCreditCard = false;
    },
  },
  watch: {
    appData: {
      handler() {
        if (isNaN(this.appData.formAmountValue)) {
          this.$root.$emit("setFormAmountValue", 0);
        }
        if (this.appData.formAmountValue > 0) {
          this.form.amount = parseFloat(this.appData.formAmountValue);
        } else {
          this.amount = 0;
          this.form.amount = 0;
        }
        window.formFieldClick("book-counter");

        if (this.appData.openModalInvitation) {
          this.fullInvitation = true;
          this.modalShow = false;
        } else {
          this.fullInvitation = false;
        }
        if (this.appData.openModalPayment) {
          this.modalShow = true;
        } else {
          this.modalShow = false;
        }
      },

      deep: true,
    },

    modalShow: function () {
      const pageTitle = document.title;
      if (this.modalShow) {
        this.isActive = false;
        document.title = "Książka" + " | " + "Formularz";
      } else {
        document.title =
          "Książka" + " | " + "Książka i twórz z nami Polskę przyjazną ";
      }
    },
  },

  components: { AmountSelect, Invitation },
  mounted() {
    let fundraiser = new URLSearchParams(location.search).get("fundraiser");
    let tag = new URLSearchParams(location.search).get("tag");
    this.remarketingWelcome = fundraiser === "###";
    this.form.amount = this.appData.formAmountValue;
    this.value = this.appData.formAmountValue;
  },
};
</script>
